var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPeopleWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3839 5.3665H10.8161C9.54237 5.3665 8.50019 4.42926 8.5 3.2836V2.24923C8.5 1.10375 9.54237 0.166504 10.8161 0.166504H11.3839C12.6578 0.166504 13.7 1.10375 13.7 2.24923V3.2836C13.7 4.42926 12.6576 5.3665 11.3839 5.3665ZM4.54023 6.5665H4.05977C2.98201 6.5665 2.10016 5.77345 2.1 4.80405V3.92881C2.1 2.95956 2.98201 2.1665 4.05977 2.1665H4.54023C5.61816 2.1665 6.5 2.95956 6.5 3.92881V4.80405C6.5 5.77345 5.61799 6.5665 4.54023 6.5665ZM6.58576 7.45578C6.28057 7.81788 6.1 8.26517 6.1 8.74867V11.7665H1.00742C0.727155 11.7665 0.5 11.5478 0.5 11.2779V8.96676C0.5 8.08439 1.2455 7.3665 2.16169 7.3665H6.03803C6.22985 7.3665 6.41418 7.39795 6.58576 7.45578ZM8.83864 6.5665H13.361C14.4302 6.5665 15.3 7.54543 15.3 8.74867V11.9002C15.3 12.2682 15.035 12.5665 14.708 12.5665H7.49199C7.16501 12.5665 6.9 12.2682 6.9 11.9002V8.74867C6.9 7.54543 7.76975 6.5665 8.83864 6.5665Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2470_23190",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 13
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3839 5.3665H10.8161C9.54237 5.3665 8.50019 4.42926 8.5 3.2836V2.24923C8.5 1.10375 9.54237 0.166504 10.8161 0.166504H11.3839C12.6578 0.166504 13.7 1.10375 13.7 2.24923V3.2836C13.7 4.42926 12.6576 5.3665 11.3839 5.3665ZM4.54023 6.5665H4.05977C2.98201 6.5665 2.10016 5.77345 2.1 4.80405V3.92881C2.1 2.95956 2.98201 2.1665 4.05977 2.1665H4.54023C5.61816 2.1665 6.5 2.95956 6.5 3.92881V4.80405C6.5 5.77345 5.61799 6.5665 4.54023 6.5665ZM6.58576 7.45578C6.28057 7.81788 6.1 8.26517 6.1 8.74867V11.7665H1.00742C0.727155 11.7665 0.5 11.5478 0.5 11.2779V8.96676C0.5 8.08439 1.2455 7.3665 2.16169 7.3665H6.03803C6.22985 7.3665 6.41418 7.39795 6.58576 7.45578ZM8.83864 6.5665H13.361C14.4302 6.5665 15.3 7.54543 15.3 8.74867V11.9002C15.3 12.2682 15.035 12.5665 14.708 12.5665H7.49199C7.16501 12.5665 6.9 12.2682 6.9 11.9002V8.74867C6.9 7.54543 7.76975 6.5665 8.83864 6.5665Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2470_23190)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-2.2998 -4.2334H17.7002V15.7666H-2.2998V-4.2334Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPeopleWhite);
export default __webpack_public_path__ + "static/media/icPeopleWhite.37b116843a5fd64eef70c72170d977cc.svg";
export { ForwardRef as ReactComponent };